<template>
  <div class="contentBox">
    <button class="btn btn-back"></button>
    <p class="title">xxx视频名称视频名称</p>
    <p class="msg">母题1</p>
    <div class="comment">
      <div class="comment-item">
        <p class="comment-title">AI点评:</p>
        <!-- <div class="comment-txt">dsafafdsfafdfsdfsdfs</div> -->
        <div class="comment-load">
          <div class="comment-loading"></div>
          <button class="btn btn-new btn-sub">重新加载AI</button>
        </div>

      </div>
      <div class="comment-item">
        <p class="comment-title">老师点评:</p>
        <div class="comment-txt">dsafafdsfafdfsdfsdfs</div>
      </div>
    </div>
    <button class="btn btn-sub">提交并查看点评</button>
  </div>
</template>
<script>
import { passwordLoginStudent ,captchaLoginStudent ,sendVerificationCode} from "@/assets/js/api";
export default {
  name: "login",
  data() {
    return {
      identityID:''
    };
  },
  mounted(){
    document.title = '登录'
  },
  methods: {
    identitySub(e){
      this.identityID = e;
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    width: 100%;
    height: 100%;
    padding: 101px 0 75px;
    background-color: #F8F9FC;
  }

  .title{
    color: #333333;
    font-size: 65px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
    width: 86px;
    height: 86px;
    background-size: 86px 86px;
    position: absolute;
    top: 40px;
    left: 60px;
  }

  .msg{
    font-size: 38px;
    margin: 15px 52px;
    color: #333333;
    display: block;
    text-align: center;
  }

  .comment{
    padding: 0 50px;
    box-sizing: border-box;
  }

  .comment-item{
    margin-top: 30px;
  }

  .comment-title{
    font-size: 32px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .comment-title::before{
    content: '';
    width: 8px;
    height: 40px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }
  
  .comment-txt{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    background-color: #EDEDED;
    border-radius: 6px;
    font-size: 22px;
    color: #333333;
    padding: 20px 30px;
    box-sizing: border-box;
    margin-top: 58px;
  }

  .btn-sub{
    font-size: 32px;
    color: #fff;
    padding: 15px 61px;
    border-radius: 60px;
    background-color: #6098F2;
    display: block;
    margin: 20px auto 0;
  }

  .comment-load{
    text-align: center;
    display: inline-block;
    vertical-align: top;
  }

  .comment-loading{
    background-image: url(~@/assets/images/icon11.png);
    width: 519px;
    height: 374px;
    background-size: 519px 374px;
  }
</style>



// WEBPACK FOOTER //
// src/identity/videoComment.vue